import { Button, Col, DatePicker, Form, Row, Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

const RefundsSearch = ({ onReset, onFinish, form, initialValues }) => {
  return (
    <Form form={form} onFinish={onFinish} initialValues={initialValues}>
      <Row gutter={16}>
        <Col>
          <Form.Item
            label="Start Date"
            name="startDate"
            rules={[
              { required: false, message: 'Please input start date!' }
            ]}>
            <DatePicker
              showNow={false}
              style={{ width: '100%' }}
              allowClear
            />
          </Form.Item>
        </Col>

        <Col>
          <Form.Item
            label="End Date"
            name="endDate"
            rules={[
              { required: false, message: 'Please input end date!' }
            ]}>
            <DatePicker
              showNow={false}
              style={{ width: '100%' }}
              allowClear
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Refund Type"
            name="isPartial"
            rules={[{ required: false }]}
            initialValue={'All'}>
            <Select
              style={{ width: 120 }}
              options={[
                { label: 'All', value: 'All' },
                { label: 'Partial', value: true },
                { label: 'Full', value: false }
              ]}></Select>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Search
            </Button>
            <Button htmlType="button" onClick={onReset}>
              Reset
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

RefundsSearch.propTypes = {
  onFinish: PropTypes.func,
  onReset: PropTypes.func,
  initialValues: PropTypes.object,
  form: PropTypes.any //change
};

RefundsSearch.defaultProps = {};

export default RefundsSearch;
